export const getNotificationSelector = (state) => {
  if (state.ui.notifications) {
    return state.ui.notifications;
  }
};
